export default __webpack_public_path__ + "static/media/DSC_wow.12c6324a.png";